import { styled } from '@mui/material/styles';
import { Fab } from '@mui/material';

export const NavToTopFab = styled(Fab)(({ theme }) => ({
  position: 'fixed',
  right: '24px',
  bottom: '24px',
  backgroundColor: theme.palette.background.paper,
  border: `2px solid ${theme.palette.secondary.main}`,
  zIndex: 100,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  '@media print': {
    display: 'none',
  },
}));

export const NavToTopText = styled('span')(({ theme }) => ({
  color: theme.palette.secondary.main,
}));

export const NavToTopWrapper = styled('div', {
  shouldForwardProp: (p) => p !== 'visible',
})(({ visible }) => ({
  display: visible ? undefined : 'none',
}));
